import { takeLatest } from 'redux-saga/effects';

import {
    GET_USERS,
    GET_USERS_SUCCESS,
    GET_USERS_FAIL,
    GET_USER_DETAIL,
    GET_USER_DETAIL_SUCCESS,
    GET_USER_DETAIL_FAIL,
} from '../../constants/actions/users.constants';
import SagaHelpers from '../../common/helpers/SagaHelpers';
import { UsersService } from '../../services/admin/UsersService';

export function* getUsers() {
    yield SagaHelpers.handleRequest({
        request: [UsersService.getUsersList, null],
        actions: [
            (payload) => ({ type: GET_USERS_SUCCESS, payload }),
            (error) => ({ type: GET_USERS_FAIL, error: error.message }),
        ],
    });
}

export function* getUserDetail(action) {
    yield SagaHelpers.handleRequest({
        request: [UsersService.getUserDetail, action.payload],
        actions: [
            (payload) => ({ type: GET_USER_DETAIL_SUCCESS, payload }),
            (error) => ({ type: GET_USER_DETAIL_FAIL, error: error.message }),
        ],
    });
}

export default [
    takeLatest(GET_USERS, getUsers),
    takeLatest(GET_USER_DETAIL, getUserDetail),
];
